<div class="flex flex-col items-center justify-center h-full gap-6">
    <p class="text-zinc-800 text-[28px] font-bold">{{ 'login' | translate }}</p>
    <form [formGroup]="form" class="flex flex-col items-center w-full max-w-[500px] gap-6" (keyup.enter)="login()">
        <app-input-email
            class="w-full"
            formControlName="email"
            rounded="xl"
            [label]="'email' | translate"
            autocomplete="username"
            placeholder="이메일을 입력해주세요."
        />

        <app-input-password
            type="password"
            [label]="'password' | translate"
            rounded="xl"
            class="w-full"
            formControlName="password"
            placeholder="비밀번호를 입력해주세요"
        />
    </form>
    <div class="flex items-center w-full max-w-[500px] justify-between">
        <div class="flex items-center gap-3">
            <app-checkbox size="sm" />
            <p class="text-sm text-zinc-800">{{ 'auto_login' | translate }}</p>
        </div>
        <div class="flex items-center">
            <app-button variant="ghost" (click)="findEmail()"
                ><span class="text-sm text-zinc-800"> {{ 'find_email' | translate }}</span></app-button
            >
            <app-button variant="ghost" (click)="findPassword()">
                <span class="text-sm text-zinc-800"> {{ 'find_password' | translate }} </span>
            </app-button>
        </div>
    </div>
    <app-button (click)="login()" rounded="xl" expand class="max-w-[500px]">{{ 'login' | translate }} </app-button>
    <div class="flex items-center gap-1">
        <p class="text-sm text-zinc-800">{{ 'signup_callout' | translate }}</p>
        <button (click)="singUp()" class="text-sm font-semibold duration-300 ease-in cursor-pointer text-primary hover:opacity-80">
            {{ 'signup' | translate }}
        </button>
    </div>
</div>
